const faqData = [
  {
    question: "What is Health Insurance?",
    answer:
      "Insurance coverage that pays for medical and surgical expenses that are incurred by the insured person during the treatment of a disease or injury. Health insurance can either reimburse the insured for expenses incurred from illness or injury or pay the care provider directly through cashless facility",
  },
  {
    question: "Why to choose ManipalCigna Sarvah?",
    answer:
      "ManipalCigna comes with 3 different plans that can provide you a coverage from the medical expense as per your requirements.",
    isList: true,
    list: [
      "ManipalCigna Sarvah – Pratham (Essential): Protect yourself with health insurance coverage securing against Cancer, Heart, Stroke, and major organ/bone marrow transplant hospitalization expenses",
      "ManipalCigna Sarvah – Uttam (Personalized): Experience peace of mind with our comprehensive hospitalization coverage which ensure you and your loved ones are protected against high medical expenses without any financial burden and provides the flexibility to add multiple optional covers to make your health coverage more personalized.",
      "ManipalCigna Sarvah – Param: Provides comprehensive hospitalization coverage which ensure you and your loved ones are protected against high medical expenses without any financial burden or any waiting period on your pre-existing medical conditions.",
    ],
  },
  {
    question: "Can I buy ManipalCigna Sarvah online?",
    answer:
      "Yes, you buy this product from our website, which is hassle free and has an easy buying process.",
  },
  {
    question: "What coverages do I get?",
    answer:
      "Under this policy, coverages are divided into basic, value added covers and optional / Rider covers. Please refer to our Accordion from the download section for more details",
  },
  {
    question: "What are the Sum Insured Options?",
    answer:
      "Multiple range of sum insured are available under this product that will help you to protect yourself and your family up to Rs 3 Cr. Sum Insured Options: ₹5 L / ₹7.5 L / ₹10L/ ₹15L/ ₹20L / ₹25L/₹50L/₹100L/ ₹200L/ ₹300L",
  },
  {
    question: "What is the minimum entry age under this ManipalCigna Sarvah?",
    answer:
      "Minimum entry age to ManipalCigna Sarvah is 18 years and above for adult and 91 days for child.",
  },
  {
    question: "Is there any tax benefit?",
    answer:
      "Yes, by buying ManipalCigna Sarvah, you can claim deduction under section 80D can save tax up to Rs. 23,400.",
  },
  {
    question:
      "What is the difference between in-patient and out-patient treatment?",
    answer:
      "When an insured is hospitalized and stays in hospital for more than 24 hours solely for receiving treatment it is termed as in-patient treatment. Out-patient treatment is when insured visits a clinic/hospital or a consultation room for diagnosis and treatment based on the advice of medical practitioner. Under out-patient treatment patient is not admitted in the hospital.",
  },
  {
    question: "What are day care procedures?",
    answer:
      "It refers to any medical treatment and/or surgical procedure which are:",
    isList: true,
    list: [
      "Undertaken under General or Local Anesthesia in a hospital/day care center in less than 24 hours because of technological advancement, and",
      "Which would have otherwise required a hospitalization of more than 24 hours. Treatment normally taken on an outpatient basis is not included in the scope of this definition.",
    ],
  },
  {
    question:
      "Are non-allopathic treatments also covered under this policy along with allopathic?",
    answer:
      "Yes, treatments under Ayurveda, Yoga and Naturopathy, Unani, Siddha and Homeopathy are covered under this Product.",
  },
  {
    question: "How is premium computed?",
    answer:
      "For calculating premium the country has been divided into 4 zones. Zone will be identified based on the location city of the insured person and premium will be calculated accordingly",
    isList: true,
    list: [
      "Zone 1 - Delhi & NCR, Districts in Gujarat: Ahmedabad, Gandhinagar, Surat, Vadodara, Districts in Maharashtra: Mumbai, Thane, Navi Mumbai, Districts in Andhra Pradesh /Telangana: Hyderabad, Khammam, Kothagudem, Hanamkonda, Warangal, Districts in Uttar Pradesh: Mathura, Jyotiba Fule Nagar (Amroha), Aligarh, Others: Rewari, Jind, Jhunjhunu, Patna",
      "Zone 2 - Rest of the Bihar State, Districts in Andhra Pradesh / Telangana: Ananthapur, Bapatla, Gadwal, Guntur, Kamareddy, Kurnool, Mahabubnagar, Medak, Nalgonda, Nellore, Nizamabad, Rangareddy, Suryapet, Wanaparthy, Districts in Punjab: Amritsar, Gurdaspur, Districts in Maharashtra: Ahmednagar, Akola, Beed, Buldhana, Jalna, Latur, Nashik, Palghar, Pune, Raigad, Others: Chennai, Bangalore, Kolkata, Dhanbad, Bokaro",
      "Zone 3 - Daman & Diu UT, Dadara & Nagar Haveli UT, Rest of Andhra Pradesh State, Rest of Telangana State, Rest of Gujarat State, Rest of Haryana State, Districts in Karnataka: Chikkaballapur, Chikkamagaluru, Kolar, Tumakuru, Udupi, Districts in Punjab: Rupnagar (Ropar), Ludhiana, Fatehgarh Sahib, S.A.S. Nagar (Mohali), Patiala, Districts in Rajasthan: Dausa, Dholpur, Jaipur, Karauli, Sawai Madhopur, Tonk, Districts in Tamilnadu: Coimbatore, Erode, Kanchipuram, Karur, Krishnagiri, Tiruppur, Tiruvallur, Districts in Uttar Pradesh: Kanpur, Banda, Fatehpur, Others: Chandigarh,  Raipur, Wayanad",
      "Zone 4 - Rest of India",
    ],
  },
  {
    question: "What is covered in organ Donor?",
    answer:
      "We will cover In-patient Hospitalization Medical Expenses for the donor for harvesting the organ, up to the Sum Insured as specified in the Policy Schedule of this Policy.",
    isList: true,
    list: [
      "Pre & Post Hospitalization expenses (Up to 30 days each) of the donor",
      "Cost towards donor screening once in a Policy year for successful transplant",
      "Complications arising during hospitalization or up to 30 days from date of discharge - up to 25% of SI subject to maximum of INR 2 Lacs, Over and above SI We will not cover expenses towards the Donor in respect of cost associated to the acquisition of the organ.",
    ],
  },
  {
    question: "What is Pre & Post hospitalisation expenses?",
    answer:
      "Pre-hospitalization expenses are medical expenses incurred immediately before the insured is hospitalized. Post-hospitalization medical expenses include expenses incurred immediately after the insured is discharged from the hospital.",
  },
  {
    question: "What is Health Check-up benefit?",
    answer:
      "For insured that have completed 18 years of age can avail a comprehensive health check-up with Our Network Provider once every year right from the first year. Coverage is inbuilt for Param plan & optional for Pratham & Uttam plan",
  },
  {
    question:
      "Is medical test mandatory for everyone before buying the policy?",
    answer:
      "Medicals will be triggered on the basis of the age of the insured, the plan type and sum insured selected apart from the health conditions declared as part of Proposal Form",
  },
  {
    question: "What do you mean by unlimited restoration of Sum Insured?",
    answer:
      "Under this benefit if the Sum Insured if not sufficient due to claims paid during the policy year then 100% of Sum Insured will get restored even in case of related illnesses Sum Insured here would mean basic Sum Insured + Gullak (Cumulative bonus) becomes insufficient",
  },
  {
    question: "What is First Year Vaccination?",
    answer:
      "It includes all reasonable and customary vaccination expenses of the new born as per the National Immunization Scheme (India) until the new born completes one year (ie.12 months). If the policy ends before the new born baby completes 12 months, this benefit will continue subject to policy being renewed in the subsequent year.",
  },
  {
    question:
      "What are the Premium payment modes available under ManipalCigna Sarvah?",
    answer:
      "You can pay your premium on monthly, quarterly, half-yearly or single as your convenience.",
  },
  {
    question:
      "What should I do if I want to insure more than 2 adults or 3 children in floater policy?",
    answer:
      "You cannot insure more than 2 adults or 3 children in a floater policy, however you can buy multi-individual policy and can enjoy additional discount of 10% on total premium.",
  },
  {
    question:
      "Would I be able to avail of my medical & premium reimbursements in case my policy is rejected?",
    answer:
      "The pre-policy medical check-up cost will be paid by ManipalCigna Health Insurance Company. In case we are unable to underwrite your proposal we will intimate the same to you and refund any premium that has been collected",
  },
  {
    question: "What are the Permanent Exclusions?",
    answer:
      "Unless necessary endorsements or exemptions are made below diseases and expenses arising out of or attributable to any of the following will not be covered in the policy. Please refer the Policy Wordings for detailed list.",
    isList: true,
    list: [
      "Investigation & Evaluation",
      "Rest Cure",
      "Rehabilitation and respite care",
      "Change-of-Gender treatments",
      "Cosmetic or Plastic Surgery",
      "Hazardous or Adventure sports",
      "Treatment for Alcoholism, drug or substance abuse or any addictive condition and consequences thereof",
      "Expenses related to the treatment for correction of eye sight due to refractive error less than 7.5 diopters",
    ],
  },
  {
    question: "Does the plan cover Pre-existing diseases?",
    answer:
      "Yes, our ManipalCigna Sarvah – Param covers the pre-existing disease without any waiting period (except initial waiting period) Waiting period for pre-existing diseases shall be 36 months for Pratham and Uttam plan",
  },
  {
    question: "Can the customer choose only one from optional covers?",
    answer:
      "Yes, customer can choose optional covers as per the requirement. Please refer policy wordings for details",
  },
  {
    question: "What do you mean by period of the policy?",
    answer:
      "The policy period is the defined timeframe during which an insurance policy is valid and provides coverage to the policyholder ManipalCigna Sarvah comes up with the 1,2 or 3 years of tenure option.",
  },
  //   {
  //     question:
  //       "Can I opt out of Gullak (Cumulative Bonus) before and after accumulating 1500% of Sum Insured?",
  //     answer:
  //       "Gullak is inbuilt cover in Param plan. It is optional for Pratham & Uttam plan and can be opted out anytime however once if opted out the accumulated bonus will not be available in your policy",
  //   },
  {
    question: "Is Medical Test mandatory for everyone?",
    answer:
      "Medicals will be triggered on the basis of the age of the insured, the plan type and sum insured selected.** For details of medical tests kindly contact Customer Support Team, Health Advisor or Branch Service Desk.",
  },
  {
    question: "Which are the medical tests one needs to go through?",
    answer:
      "The list of medical tests will be communicated by ManipalCigna Health Insurance Company to the customer at the time of processing the insurance application as they will depend upon the Age, Sum Insured opted and any medical history declared at the time of application.",
  },
  {
    question: "What is the Grace Period in the Policy?",
    answer:
      "Your health insurance grace period is the extra time that you are given in case you miss your policy renewal premium due date.In case of monthly mode of payment, grace period will be 15 days, in any other case, grace period will be 30 days.",
  },
  {
    question: "What is Tele - consultations feature in the product?",
    answer:
      "An Insured Person may avail tele-consultations with our General Physician through our network in India for the unlimited times. For the purpose of this benefit, tele-consultation shall mean consultation provided by a Medical Practitioner through various mode of communication available through tele/chat mode.",
  },
  {
    question: "Is Nomination compulsory in this policy?",
    answer: "Yes, Nomination is mandatory in this policy",
  },
];

export default faqData;
